import LogRocket from 'logrocket';
import { useEffect, useRef } from 'react';
import { useMe } from './me';

const APP_ID = 'g2st7o/clockwise';

let initialized = false;

/**
 * Initialize LogRocket in production builds only. `import.meta.env.PROD` is
 * true for `vite build` output (Cloud Run image) and false for `vite dev` /
 * `vite --mode e2e`, so local and e2e sessions aren't recorded.
 *
 * Clockwise uses its own LogRocket project (`g2st7o/clockwise`), separate
 * from inboxpulse (`g2st7o/mscfo`), so recordings, quotas, and dashboards
 * stay isolated between the two products.
 */
export function initLogRocket(): void {
  if (initialized) return;
  if (!import.meta.env.PROD) return;
  LogRocket.init(APP_ID);
  initialized = true;
}

/**
 * Identify the current user to LogRocket once `useMe()` resolves. Safe to call
 * unconditionally — falls through when LogRocket wasn't initialized.
 */
export function useLogRocketIdentify(): void {
  const { user } = useMe();
  const identified = useRef(false);

  useEffect(() => {
    if (!initialized) return;
    if (identified.current) return;
    if (!user) return;
    identified.current = true;
    LogRocket.identify(user.id, {
      email: user.email,
      name: `${user.firstName} ${user.lastName}`.trim(),
      tenantId: user.tenantId,
      app: 'clockwise',
    });
  }, [user]);
}
